import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class ActivityRosterBuilderApi {
  // ------ Roster Builder API ------
  static getAllActivityRosterBuilders(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.activityRosterBuildersList, { params });
  }

  static getActivityRosterBuilder({ id }) {
    return axios.get(ApiEndpoints.activityRosterBuilder.replace(':id:', id));
  }

  static createActivityRosterBuilder(params) {
    return axios.post(ApiEndpoints.activityRosterBuildersList, params);
  }

  static cloneActivityRosterBuilder(id) {
    return axios.post(ApiEndpoints.activityRosterBuilderClone.replace(':id:', id));
  }

  static updateActivityRosterBuilder(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.activityRosterBuilder.replace(':id:', id), data);
  }

  static deleteActivityRosterBuilder({ id }) {
    return axios.delete(ApiEndpoints.activityRosterBuilder.replace(':id:', id));
  }

  // ------ Saves the activities -------
  static saveActivityRosterBuilderActivities(rosterBuilder_id, activities) {
    return axios.post(
      `${ApiEndpoints.activityRosterBuilderActivities.replace(':id:', rosterBuilder_id)}bulk_update/`,
      activities
    );
  }

  // ------ Add to Roster ----------
  static addRosterBuilderToRoster(rosterBuilder_id, values) {
    return axios.post(
      `${ApiEndpoints.activityRosterBuilderActivities.replace(':id:', rosterBuilder_id)}add_to_roster/`,
      values
    );
  }
}

export default ActivityRosterBuilderApi;
